import { Helper } from "../core/util/helper.js";
import React from "react"
export class AdminInfo extends React.Component<any, any>{

    constructor(props) {
        super(props)

        console.log(props)
    }

    private sort = (a: string, b: string) => {
        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    }

    private styleValue = (value) => {
        switch (typeof value) {
            case "number": 
                return value.toLocaleString();
            case "string":
                if (Helper.isNullOrEmpty(value)) 
                    return "n/a";
                else 
                    return value;
            case "boolean":
                if (value)
                    return <i className="fa-light fa-check"></i>
                else 
                    return <i className="fa-light fa-xmark"></i>
            default:
                return "n/a"
        }
    }

    private renderWebCongigInfo = () => {
        const keys = Object.keys(this.props).filter(f => f != "ConnectionInfo").sort(this.sort);
        let infos = keys.map((key, index) => {
            return (
                <React.Fragment key={key}>
                    <div style={{ display: "flex", alignItems: "center", fontSize: "1.5em", gridColumn: "1/2", gridRow: `${index + 2}/${index + 3}`, lineBreak: "anywhere" }}>
                        {key.replace(/__/g, ":", ).replace(/_/g, ".", )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5em", gridColumn: "2/3", gridRow: `${index + 2}/${index + 3}`, lineBreak: "anywhere" }}>
                        {this.styleValue(this.props[key])}
                    </div>
                </React.Fragment>
            );
        })

        return (
            <div style={{ gridTemplateRows: `45px repeat(${keys.length}, minmax(35px, min-content))`, gridColumn: "1/2" }} className="adminInfo__infoBlock">
                <div style={{ gridRow: "1/2", gridColumn: "1/3", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "2em", borderBottom: "1px solid black" }}>Web.config</div>
                {infos}
            </div>
        )
    } 

    private renderDataBaseInfo = () => {
        const keys = Object.keys(this.props.ConnectionInfo).sort(this.sort);
        let infos = keys.map((key, index) => {
            return (
                <React.Fragment key={key}>
                    <div style={{ display: "flex", alignItems: "center", fontSize: "1.5em", gridColumn: "1/2", gridRow: `${index + 2}/${index + 3}` }}>
                        {key}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5em", gridColumn: "2/3", gridRow: `${index + 2}/${index + 3}` }}>
                        {this.styleValue(this.props.ConnectionInfo[key])}
                    </div>
                </React.Fragment>
            );
        })


        return (
            <div style={{ gridTemplateRows: `45px repeat(${keys.length}, minmax(35px, min-content))`, gridColumn: "2/3" }} className="adminInfo__infoBlock">
                <div style={{ gridRow: "1/2", gridColumn: "1/3", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "2em", borderBottom: "1px solid black" }}>Database connection</div>
                {infos}
            </div>
        )
    }

    render() {
        const wrappingSize = 1200;
        return (
            <>
                <style>
                    {`
                        .adminInfo{
                            height: 100%;
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            overflow: auto;
                        }

                        .adminInfo__infoBlock{
                            display: grid;
                            grid-template-rows: 1fr 1fr;
                            padding: 8px;
                            width: 50%;
                            grid-gap: 5px;
                        }   

                        @media (max-width: ${wrappingSize}px) {
                           .adminInfo__infoBlock{
                                width: 100%;
                            }   
                        }

                        .adminInfo__infoBlock > div:first-child{
                            grid-area: 1 / 1 / 2 / 3;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 2em;
                            border-bottom: 1px solid black;
                        }                  
                    `}

                </style>

                <div className="adminInfo">
                    {this.renderWebCongigInfo()}
                    {this.renderDataBaseInfo()}
                </div>    
            </>
        );
    }
}